import React from 'react';
export function EditIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.414 6L16 1.586 3.148 14.438l-2.076 5.19 1.3 1.3 5.19-2.076L20.414 6zM3.795 18.205l1.057-2.643L16 4.414 17.586 6 6.438 17.148l-2.643 1.057z"
  }), React.createElement("path", {
    d: "M8 22l2-2h12v2H8z"
  }));
}